export const C = {
  ink: '#0A1A1E',
  slate: '#12262B',
  text: '#1B2533',
  muted: '#5C6A7A',
  faint: '#8B97A8',
  line: '#E4E8EE',
  lineSoft: '#EEF1F5',
  surface: '#FAFBFC',
  teal: '#15A08C',
  tealD: '#0F8474',
  tealInk: '#0B6B5C',
  tealSoft: '#EAF6F3',
  green: '#0D8050',
  greenSoft: '#E4F5EC',
  amber: '#9C5A0F',
  amberSoft: '#FBF1DD',
} as const;